import axios from 'axios'
import React, { useCallback, useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { domainWeb } from '../../config/constants'
import { authenticated } from '../../recoil/auth'
import { commentLoading, commentData } from '../../recoil/comment'
import WaitingText from '../WaitingText'
import CommentItem from './CommentItem'

const CommentsCard = (props) => {
  const auth = useRecoilValue(authenticated);
  const [loading, setLoading] = useRecoilState(commentLoading);
  const [data, setData] = useRecoilState(commentData);
  
  const getComments = useCallback(async () => {
    setLoading(true);
    try {
      let url = `${domainWeb}/contents/${props.content}/comments`;
      let response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json', 
          'Accept': 'application/json', 
          'Authorization': 'Bearer ' + auth.token
        },
      });
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }, [auth.token, props.content, setData, setLoading]);

  const loadData = () => {
    if (loading) {
      return <div className="mt-5"><WaitingText /></div>;
    }
    if (data.length === 0) {
      return <div className="mt-5 italic text-slate-500">Belum ada yang mengomentari konten ini.</div>;
    }
    return (
      <div className="flex flex-col mt-5">
        {
          data.map((item, i) => <CommentItem key={i} data={item} />)
        }
      </div>
    );
  };

  useEffect(() => {
    getComments();
  }, [getComments]);

  return (
    <div className="flex-1 px-8 py-5 bg-white rounded-lg shadow">
      <h3 className="text-xl font-semibold">{`Komentar (${data.length})`}</h3>
      {loadData()}
    </div>
  )
}

export default CommentsCard